import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=a24059f6&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24059f6",
  null
  
)

export default component.exports